import { analytics } from '../firebase';
import { logEvent, CustomEventName } from 'firebase/analytics';
import { logger } from './logger';

type EventName = 
  | 'login'
  | 'signup'
  | 'page_view'
  | 'button_click'
  | 'form_submit'
  | 'error';

interface AnalyticsEvent {
  name: EventName;
  params?: Record<string, any>;
}

class Analytics {
  private isInitialized = false;
  private queue: AnalyticsEvent[] = [];

  initialize() {
    if (this.isInitialized) return;
    this.processQueue();
    this.isInitialized = true;
  }

  private processQueue() {
    while (this.queue.length > 0) {
      const event = this.queue.shift();
      if (event) this.trackEvent(event.name, event.params);
    }
  }

  trackEvent(name: EventName, params?: Record<string, any>) {
    analytics.then(analyticsInstance => {
      if (!analyticsInstance) {
        this.queue.push({ name, params });
        return;
      }

      try {
        logEvent(analyticsInstance, name as CustomEventName<EventName>, params);
        logger.info(`Analytics event tracked: ${name}`, params);
      } catch (error) {
        logger.error(`Failed to track analytics event: ${name}`, error as Error);
      }
    });
  }

  setUser(userId: string, properties?: Record<string, any>) {
    if (!analytics) return;
    // Set user properties in analytics
  }

  clearUser() {
    if (!analytics) return;
    // Clear user properties
  }
}

export const analyticsService = new Analytics();

export const monitoringConfig = {
  sampleRate: 0.1,  // 10% of users
  sessionTimeout: 30,  // minutes
  errorThresholds: {
    jsErrors: 0.01,  // 1% allowed
    apiErrors: 0.05,  // 5% allowed
    authErrors: 0.001 // 0.1% allowed
  }
};
